'use client';

import { BookOpen, Brain, Briefcase, Building, Calendar, ExternalLink, GraduationCap, HelpCircle, Home, Newspaper } from 'lucide-react';

type QuickLink = {
  groupKey: string;
  groupValue: string;
  children: {
    label: string;
    url: string;
    icon: React.ElementType;
    meta?: string;
    target?: string;
  }[];
};

export const QUICK_LINKS: QuickLink[] = [
  {
    groupKey: 'Main Pages',
    groupValue: 'Main Pages',
    children: [
      {
        label: 'Home',
        url: '/',
        icon: Home,
      },
      {
        label: 'Careers',
        url: '/careers',
        icon: GraduationCap,
      },
      {
        label: 'Resources',
        url: '/resources',
        icon: BookOpen,
      },
      {
        label: 'Stories',
        url: '/stories',
        icon: Newspaper,
      },
    ],
  },
  {
    groupKey: 'More',
    groupValue: 'More',
    children: [
      {
        label: 'Opportunities',
        url: '/opportunities',
        icon: Briefcase,
      },
      {
        label: 'Events',
        url: '/events',
        icon: Calendar,
      },
      {
        label: 'FAQ',
        url: '/faq',
        icon: HelpCircle,
      },
      {
        label: 'Institutions',
        url: '/institutions',
        icon: Building,
      },
      {
        label: 'Quizzes',
        url: '/quizzes',
        icon: Brain,
      },
    ],
  },
  {
    groupKey: 'External',
    groupValue: 'External',
    children: [
      {
        label: 'Contact Us',
        url: 'https://www.moh.gov.rw/contact',
        icon: ExternalLink,
        target: '_blank',
      },
    ],
  },
];
